import { Link } from 'react-router-dom'
import { Breadcrumb ,message, Form,
  Input,
  InputNumber,
  Cascader,
  Row,
  Col,
  Checkbox,
  Button,
  AutoComplete, 
  ConfigProvider} from 'antd';
import copy from "copy-to-clipboard";
import './BecomeADistributor.less'
import { InstagramOutlined, TwitterOutlined, FacebookOutlined } from '@ant-design/icons';
import {post} from '../../request/request'
import { useIntl } from 'react-intl';

const handleCopy = (value:any) => {
	copy(value);
	message.success('Copy successful!');
}


const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 24 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
  },
};


export default () => {
	const [form] = Form.useForm();
	const intl = useIntl();
	
	const onFinish = (values: any) => {
		post('snailcar/info/common/partnerSnailCar',{...values
	}).then((data) => {
		console.log(data)
		message.success('successful!');
		form.resetFields();
	})
	};
	return (
	<div className="BecomeADistributor">
		<div className='news-banner-wrapper'>
            <img className='distibutor-img' src="https://obs-pipishou.obs.cn-east-3.myhuaweicloud.com/SnailBicycle/SnailBicycl/course/16705550769092235.png" alt="" />
            <div className='news-banner-title'><span>{intl.formatMessage({id: 'distributor.title'})}</span></div>
        </div>
		<div className="BecomeADistributor-footer-wrapper">
			<div className="title">{intl.formatMessage({id: 'distributor.toBecome'})}</div>
			<div className="flex-wrapper">
				<div  className="content-block-left">
					<img src="https://obs-pipishou.obs.cn-east-3.myhuaweicloud.com/SnailBicycle/SnailBicycl/course/16704845205299442.png" alt="" />
					<ul className='content'>
						<li>{intl.formatMessage({id: 'distributor.con'})}</li>
						<li>{intl.formatMessage({id: 'distributor.con1'})}</li>
						<li>{intl.formatMessage({id: 'distributor.con2'})}</li>
						<li>{intl.formatMessage({id: 'distributor.con3'})}</li>
						<li>{intl.formatMessage({id: 'distributor.con4'})}</li>
					</ul>
				</div>
				<div className="content-block-right" >
					<div className="content">{intl.formatMessage({id: 'distributor.contact'})}</div>
					<ConfigProvider
						// theme={{
						// 	token: {
						// 	colorPrimary: '#647283',
						// 	},
						// }}
						>
					<Form
						form={form}
						layout="vertical"
						name="register"
						onFinish={onFinish}
						initialValues={{
						residence: ['zhejiang', 'hangzhou', 'xihu'],
						prefix: '86',
						}}
						size={'large'}
						scrollToFirstError
						className='form-wrapper'
					>
						<Form.Item
						name="name"
						label={intl.formatMessage({id: 'form.label.Name'})}
						>
						<Input />
						</Form.Item>

						<Form.Item
						name="company"
						label={intl.formatMessage({id: 'form.label.Company'})}
						>
						<Input style={{ width: '100%' }} />
						</Form.Item>

						<Form.Item
						name="email"
						label={intl.formatMessage({id: 'form.label.email'})}
						rules={[
							{
							type: 'email',
							message: intl.formatMessage({id: 'form.message.valid.email'}),
							},
							{
							required: true,
							message: intl.formatMessage({id: 'form.message.enter.email'}),
							},
						]}
						>
						<Input />
						</Form.Item>

						<Form.Item
						name="comment"
						label={intl.formatMessage({id: 'form.label.Comment'})}
						rules={[{ required: true, message: intl.formatMessage({id: 'form.message.comment'}) }]}
						>
						<Input.TextArea placeholder={intl.formatMessage({id: 'form.message.enter.comment'})} style={{minHeight: '200px'}} />
						</Form.Item>
						<Form.Item >
						<Button type="primary" htmlType="submit" shape="round" block>{intl.formatMessage({id: 'form.btn.sub'})}</Button>
						</Form.Item>
					</Form>
					</ConfigProvider>
				</div>
			</div>
			<div className="title">{intl.formatMessage({id: 'distributor.title'})}.</div>
			<div  className="flex-wrapper">
				<div className="content-block-left">
					<p>{intl.formatMessage({id: 'distributor.phone'})}</p>
					<p className='font-bold' style={{marginBottom: 20}}>0086 592 6261321 </p>
					<p>{intl.formatMessage({id: 'distributor.email'})}</p>
					<p className='font-bold'>support@snailcle.com</p>
				</div>
				<div className="content-block-right">
					<p>{intl.formatMessage({id: 'distributor.join'})}</p>
					<div className='link-wrapper'>
						<a target={'_blank'} href="https://www.instagram.com/snailcle_world/"><Button type="primary" icon={<InstagramOutlined />} size={"large"}/></a>
						<a target={'_blank'} href="https://twitter.com/snailcleworld"><Button type="primary" icon={<FacebookOutlined />} size={"large"}/></a>
						<a target={'_blank'} href="https://www.facebook.com/search/top/?q=Hello%20Snailcle"><Button type="primary" icon={<TwitterOutlined />} size={"large"}/></a>
					</div>
				</div>
			</div>
		</div>
	</div>
)}